import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar/AppBar";
import Hidden from "@material-ui/core/Hidden";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import Typography from "@material-ui/core/Typography/Typography";
import ToolbarList from "./ToolbarList";
import Stepper from "./Stepper";
import { useTranslation } from "react-i18next";

const hideTitleForClients = ['still'];
const showTitle = hideTitleForClients.indexOf(new URL(window.location).searchParams.get('_client')) === -1;

const useStyles = makeStyles(
  (theme) => ({
    root: {
      flexGrow: 1,
    },
    grow: {
      flexGrow: 1,
    },
    headerRoot: {
      overflow: "hidden",
      boxShadow: "none",
      backgroundColor: "#ffffff",
    },
    toolbarHeaderWrapper: {
      minHeight: 64,
      padding: "0 20px",
      [theme.breakpoints.down("xs")]: {
        padding: "0 0 0 20px",
      },
    },
    hiddenEmailShareIframe: {
      visibility: "hidden",
      position: "absolute",
    },
    typographyBody: {
      fontWeight: "bold",
    },
  }),
  {
    name: "Header",
  }
);

const Header = (props) => {
  const classes = useStyles(props);
  const { t } = useTranslation(["header", "common"]);
  const { title, steps, loadConfiguration, saveConfiguration, downloadPdf } = props;
  const tools = [
    {
      key: "save",
      identifier: "cloud_download",
      title: t("save"),
      function: () => saveConfiguration(),
    },
    {
      key: "load",
      identifier: "cloud_upload",
      title: t("load"),
      function: () => loadConfiguration(),
    },
    {
      key: "picture_as_pdf",
      identifier: "picture_as_pdf",
      title: t("saveAsPdf"),
      function: () => downloadPdf(),
    },
  ];

  return (
    <div className={classes.root}>
      <AppBar color="#ffffff" position="static" className={classes.headerRoot}>
        <Toolbar classes={{ regular: classes.toolbarHeaderWrapper }}>
          {showTitle && (
            <Hidden xsDown>
              <div className={classes.itemInfoWrapper}>
                <Typography classes={{ body2: classes.typographyBody }} variant="body2">
                  {title}
                </Typography>
              </div>
            </Hidden>
          )}
          <div className={classes.grow}>{steps && <Stepper tabs={steps} />}</div>
          <ToolbarList tools={tools} />
        </Toolbar>
      </AppBar>
    </div>
  );
};

Header.propTypes = {
  tools: PropTypes.array,
  steps: PropTypes.array,
  variants: PropTypes.array,
  selectedVariantIdentifier: PropTypes.string,
  title: PropTypes.string,
  switchSelectedAmount: PropTypes.func,
  VariantChooserComponent: PropTypes.elementType,
};

export default Header;
